/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DataStore, DataStoreInterface } from "../DataStore";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenterAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EDITOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_key",
        type: "uint256",
      },
    ],
    name: "getUint",
    outputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_URI",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_key",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "setUint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type DataStoreConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DataStoreConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DataStore__factory extends ContractFactory {
  constructor(...args: DataStoreConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenterAddress: string,
    _trustedForwarder: string,
    _uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DataStore> {
    return super.deploy(
      _controlCenterAddress,
      _trustedForwarder,
      _uri,
      overrides || {}
    ) as Promise<DataStore>;
  }
  getDeployTransaction(
    _controlCenterAddress: string,
    _trustedForwarder: string,
    _uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenterAddress,
      _trustedForwarder,
      _uri,
      overrides || {}
    );
  }
  attach(address: string): DataStore {
    return super.attach(address) as DataStore;
  }
  connect(signer: Signer): DataStore__factory {
    return super.connect(signer) as DataStore__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DataStoreInterface {
    return new utils.Interface(_abi) as DataStoreInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DataStore {
    return new Contract(address, _abi, signerOrProvider) as DataStore;
  }
}
